<section class="page-title-area">
  <div class="container">
    <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea;">
      <h2>{{pageTitle.title}}</h2>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{pageTitle.title}}</li>
        <li>{{pageTitle.subTitle}}</li>
      </ul>
    </div>
  </div>

  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
  <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
  <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="case-studies-details-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <app-gallery-restaurante></app-gallery-restaurante>
        <div class="case-studies-details-desc">
          <h3>Restaurante</h3>
          <h4>Para recuperar a energia com prazer</h4>
          <p style="text-align: justify;">O restaurante CTC oferece café da manhã, almoço e jantar diariamente. Seu café
            da manhã completo e saboroso, é de produção totalmente própria em nossa padaria e nos preocupamos em
            oferecer alimentos saboroso, agradáveis mais também seguros e nutritivos. O almoço oferece cardápios com as
            delícias internacionais e regionais para atender e surpreender a todos os paladares e no jantar, o
            tradicional buffet de caldos e massa, uma refeição leve e reconfortante para fechar o dia com chave de ouro
            (ou iniciar uma noite badalada!)</p>
          <p>
            <strong>Café da Manhã de 07h às 09h30<br>
              Almoço de 11h30 às 14h30<br>
              Jantar 19h às 21h30<br></strong>
          </p>
        </div>
        <div class="case-studies-details-desc" *ngFor="let DetailsDesc of caseStudiesDetailsDesc;">
          <h3 *ngIf="DetailsDesc.title">{{DetailsDesc.title}}</h3>
          <p *ngIf="DetailsDesc.paragraph" style="text-align: justify;">{{DetailsDesc.paragraph}}</p>
        </div>
      </div>

    </div>
  </div>
</section>
